import { useEffect } from "react";
import { createActorContext } from "@xstate/react";
import { useRouter } from "next/router";
import { useAuth0 } from "@auth0/auth0-react";
import { routingMachine } from "../utils/routingStateMachine/routingStateMachine";
import { useToggle } from "../utils/hooks/useToggle";
import { LoadingOrError } from "../components/common/LoadingOrError";
export var RoutingMachineContext = createActorContext(routingMachine, {
    devTools: true,
});
export function RoutingMachineProvider(_a) {
    var children = _a.children;
    var router = useRouter();
    var user = useAuth0().user;
    var _b = useToggle(false), toggle = _b.toggle, isReady = _b.value;
    useEffect(function () {
        if (router.isReady && !isReady) {
            toggle();
        }
    }, [router.isReady, toggle, isReady]);
    var getInitialStateUsingPathName = function () {
        var runtimeInitialState = router.pathname.replace(/^\//g, "");
        if (runtimeInitialState !== "") {
            return runtimeInitialState;
        }
        else {
            return "root";
        }
    };
    var runtimeInitialState = "root";
    if (router.pathname.includes("referral/c2c")) {
        runtimeInitialState = "referral/c2c";
    }
    if (isReady && !user) {
        runtimeInitialState = getInitialStateUsingPathName();
    }
    if (isReady && user && router.pathname.includes("claim-loan")) {
        runtimeInitialState = "claim-loan";
    }
    // If the user is not logged in, the user can land in one of five pages:
    // 1- start-loan
    // 2- sign-in
    // 3- sign-up
    // 4- sign-up-verify-account
    // 5- forgot-password
    // We get the current URL and create the machine with the matching state
    // If the user is logged in, we get the "currentState" value from Hasura
    // With this value, we create the machine with that state
    // Once the machine is set to a specific state, it will take care of sending
    // the user to the appropriate page
    // We need to wait for the router to be ready so the query params are populated
    // in the router that we'll send into the machine's context
    return (<LoadingOrError loading={!isReady}>
      <RoutingMachineContext.Provider options={{
            context: {
                router: router,
                runtimeInitialState: runtimeInitialState,
                user: user,
            },
        }}>
        {children}
      </RoutingMachineContext.Provider>
    </LoadingOrError>);
}
//# sourceMappingURL=data:application/json;base64,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